import { render, staticRenderFns } from "./questions-choice.vue?vue&type=template&id=1c00e088&scoped=true&"
import script from "./questions-choice.vue?vue&type=script&lang=js&"
export * from "./questions-choice.vue?vue&type=script&lang=js&"
import style0 from "./questions-choice.vue?vue&type=style&index=0&id=1c00e088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c00e088",
  null
  
)

export default component.exports